<template>
  <div class="noipAtlas">
    <!-- header -->
    <div class="headerView">
      <div class="filter">
        <label class="text">用户:</label>
        <!-- <input placeholder="输入手机号" v-model="filter_owner"/> -->
        <textarea
          v-model="filter_owner"
          placeholder="请输入手机号,使用回车分隔"
          rows="4"
        ></textarea>
      </div>

      <div class="filter">
        <label class="text">课程id:</label>
        <input placeholder="输入课程id" v-model="filter_course_id"/>
      </div>

      <!-- <div class="filter">
        <label class="text">教室id:</label>
        <input placeholder="输入教室id" v-model="filter_classroom_id"/>
      </div> -->

      <button class="commonBtn" @click="filterLiveClassroomAcademic()">筛选</button>
    </div>
    <!-- 数据表格 -->
    <div class="list">
      <table class="infoTable">
        <tbody>
          <tr class="infoLabel">
            <th class="text">真实姓名</th>
            <th class="text">昵称</th>
            <th class="text">账号</th>
            <th class="text">直播课程</th>
            <th class="text">直播教室</th>
            <th class="text">是否回放</th>
            <th class="text">到课时间</th>
            <th class="text">到课距今时间</th>
          </tr>
          <tr
            :class="
              `infoValue ${
                (data.length % 2 === 0 && index % 2 !== 0) || (data.length % 2 !== 0 && index % 2 === 0)
                  ? 'blue'
                  : 'white'
              }`
            "
            v-for="(item, index) in data"
            :key="item.id"
          >
            <td class="text">{{ item.owner && item.owner.realname }}</td>
            <td class="text">{{ item.owner && item.owner.name }}</td>
            <td class="text">{{ item.owner && item.owner.user }}</td>
            <td class="text">{{ item.live_course.title }}({{item.live_course.id}})</td>
            <td class="text">{{ item.live_classroom.title }}({{item.live_classroom.id}})</td>
            <td class="text">
              <div class="booleanTextContainer">
                <div :class="item.is_watch_replay? 'isTrueText' : null">
                  {{ item.is_watch_replay ? "是" : "否" }}
                </div>
              </div>
            </td>
            <td class="text">{{ item.watch_replay_time ? item.watch_replay_time.replace('T', ' ').split('.')[0] : '无数据'}}</td>
            <td class="text">{{ item.watch_replay_time ? calTimeDelay(item.watch_replay_time) : '无数据'}}</td>

          </tr>
        </tbody>
      </table>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total_count"
        :current-page="page"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>

import { types as AcademicTypes } from "@/store/modules/academic";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "LiveAiClassroomAcademic",
  data() {
    return {
      // 手机号
      filter_owner: null,
      // 课程id
      filter_course_id: null,
      // 当前直播教室的 pk
      filter_classroom_id: null,

      //   当前用户的账号
      current_owner: null,

      //过滤框索引下标
      team_index: -1,
      user_index: -1,
      classroom_index: -1,
      selectTextWidth:{
        width:"450px",
      }
    };
  },
  computed: {
    ...mapState({
      page: (state) => state.academic.ai_classroom.page,
      total_count: (state) => state.academic.ai_classroom.total_count,
      data: (state) => state.academic.ai_classroom.data,
    }),
    ...mapGetters({
    }),
  },
  watch: {
  },
  created() {},
  methods: {
    ...mapMutations({}),
    ...mapActions({
      fetchStudentAcademicClassroomData: AcademicTypes.FETCH_LIST_DATA_AI_CLASSROOM,
    }),

    // 请求学生学情-教室数据
    filterLiveClassroomAcademic(page = 1) {
      console.log(this.filter_owner)
      if (!this.filter_owner) {
        this.$message.error("请输入手机号")
        return
      }
      if (!this.filter_course_id) {
        this.$message.error("请输入课程id")
        return
      }
      
      let students = this.filter_owner.split("\n")

      let dic = { page: page };

      if (this.filter_course_id) {
        dic = { ...dic, live_course_id: this.filter_course_id };
      }

      if (students) {
        students.map(item=>{
          if (item.includes('+')) {
            return encodeURIComponent(students)
          } else {
            return item
          }
        })
        students = students.join(',')
        dic = { ...dic, students: students };
      } else {
        this.$message.error("手机号错误")
      }

      this.fetchStudentAcademicClassroomData(dic);
    },

    //修改页码
    changePage(val) {
      this.filterLiveClassroomAcademic(val);
    },
    calTimeDelay(input_time) {
      let now_date = new Date().getTime();
      let input_date = new Date(input_time).getTime();
      let diff_date_time = Math.abs(now_date - input_date);
      let diff_day = Math.floor(diff_date_time / 86400000) // 1000 * 3600 * 24
      return `${diff_day}天`
    }
  },
  mounted() {
  },
};
</script>
<style scoped lang="less">
.noipAtlas {
  width: 100%;

  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #f5f5f5;
  .list {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 21px 0px rgba(48, 115, 248, 0.1);
    border-radius: 10px;
    padding: 15px;
    text-align: center;
    min-width: 500px;
    .infoTable {
      padding: 20px;
      width: 100%;
      border-spacing: 0px;
      margin-bottom: 20px;
      .infoLabel {
        background-color: #5f0aff;
        height: 70px;
        color: white;
        .text {
          text-align: center;
          vertical-align: middle;
        }
      }
      .infoValue {
        height: 60px;
        font-size: 16px;
        color: #333;
        &.blue {
          background-color: #f2f7ff;
        }
        &.white {
          background-color: #ffffff;
        }
        .text {
          text-align: center;
          vertical-align: middle;
        }
        .btn {
          display: inline-block;
          height: 32px;
          line-height: 32px;
          background: #5f0aff;
          border-radius: 16px;
          color: #fff;
          padding: 0 14px;
          cursor: pointer;
          font-size: 14px;
        }
      }
    }
  }

  .headerView {
    flex-direction: row;
    display: flex;
    align-items: center;
    height: 80px;
    border-radius: 10px;
    background: #fff;
    font-size: 20px;
    padding-left: 20px;
    margin-bottom: 15px;
    .filter {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 30px;
      .text {
        color: #333333;
        font-size: 16px;
        margin-right: 15px;
      }
      input {
        height: 36px;
        border-radius: 18px;
        background: #ECF3FF;
        font-size: 16px;
        color: #999999;
        width: 230px;
        padding: 0;
        padding-left: 10px;
        border: none;
        margin-left: 30px;
        margin-right: 17px;
      }
    }
    .commonBtn {
      height: 36px;
      width: 80px;
      font-size: 16px;
      color: #fff;
      border-radius: 18px;
      background: #5F0AFF;
      cursor: pointer;
    }
  }
  .booleanTextContainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .isTrueText {
    border: 1px solid #67C23A;
    border-radius: 2rem;
    background-color: #67C23A;
    padding: 10px 20px;
    color: white;
  }
}
</style>
